import React, { useState, useEffect, useRef, forwardRef } from 'react';
import MenuHome from './MenuHome';
import Slideshow from './Slideshow';
import StanInfo from './StanInfo';
import KontaktInfo from './KontakInfo';
import slika1 from '../assets/slika1.jpeg';
import slika2 from '../assets/slika2.jpeg';
import slika3 from '../assets/slika3.jpeg';
import slika4 from '../assets/slika4.jpg';
import slika5 from '../assets/slika5.jpg';
import slika6 from '../assets/slika6.jpg';
import slika7 from '../assets/slika7.jpeg';
import slika8 from '../assets/slika8.jpeg';

const Home = forwardRef(({ setIsHeaderVisible, onSearch, handleProdajaClick, handleIzdavanjeClick }, ref) => {
  const [isTextVisible, setIsTextVisible] = useState(false);
  const [currentSlideshow, setCurrentSlideshow] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const homeRef = useRef(null);

  const stan1Images = [slika1, slika2, slika3];
  const stan2Images = [slika4, slika5, slika6];
  const stan3Images = [slika7, slika8, slika3];
  const slideshowTitles = [
    "Novi Sad, Bulevar Oslobođenja, 330 €",
    "Novi Sad, Bulevar Oslobođenja, 84.500 €",
    "Novi Sad, Bulevar Oslobođenja, 700 €"
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsTextVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (homeRef.current) {
      observer.observe(homeRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentSlideshow((prevIndex) => (prevIndex + 1) % 3);
      }, 6000);

      return () => clearInterval(interval);
    }
  }, [isPaused]);

  useEffect(() => {
    if (setIsHeaderVisible) {
      setIsHeaderVisible(true);
    }
  }, [setIsHeaderVisible]);

  return (
    <div className="relative w-screen h-screen" ref={homeRef}>
      <section
        id="home-section"
        className="w-full h-full bg-gray-900 text-white flex flex-col items-center md:items-start justify-start p-2 sm:p-4 md:p-16 md:pt-48 pt-16 sm:pt-0 pb-8 home-medium-screen"
      >
        {/* MenuHome za veće ekrane */}
        <div className="ml-4 hidden md:block">
          <MenuHome onSearch={onSearch} />
        </div>

        {/* Komponente za ekrane ispod 770px */} 
        <div className="block md:hidden w-full flex flex-col items-center">
          {/* MenuHome za manje ekrane */}
          <div className="mt-4 pt-8 w-full px-4 menu-home-small menu-home-medium">
            <MenuHome onSearch={onSearch} />
          </div>

          {/* Uvodni tekst za manje ekrane */}
          <div className="mt-6 px-4 text-center border-t-2 border-pink-500 pt-2 max-w-xs intro-text-small intro-text-medium">
            <h2 className="text-base font-bold text-pink-500 tracking-wider">
              ZY kvadrat nekretnine
            </h2>
            <p className="mt-2 text-xs text-gray-300 leading-snug">
              Dug period uspešno posredujemo na tržištu nekretnina u Novom Sadu.
            </p>
            <p className="mt-2 text-xs text-gray-300 leading-snug">
              Agencija ZY kvadrat nekretnine je upisana u Registar posrednika pod brojem 1018.
            </p>
          </div>

          {/* KontaktInfo za manje ekrane */}
          <div className="mt-4 w-full px-4 contact-info-small contact-info-medium">
            <KontaktInfo className="text-xs leading-snug p-2" />
          </div>

          {/* Dugmad za manje ekrane */}
          <div className="mt-2 flex space-x-4 w-full px-4 justify-center">
            <button
              className="bg-pink-600 text-black py-2 px-4 rounded-lg hover:bg-pink-700 transition-all w-1/2 text-xs mb-2 button-small button-medium"
              onClick={handleIzdavanjeClick}
            >
              IZNAJMI
            </button>
            <button
              className="bg-pink-600 text-black py-2 px-4 rounded-lg hover:bg-pink-700 transition-all w-1/2 text-xs mb-2 button-small button-medium"
              onClick={handleProdajaClick}
            >
              KUPI
            </button>
          </div>
        </div>

        {/* Uvodni tekst za veće ekrane */}
        {isTextVisible && (
          <div className="hidden sm:block mt-32 md:mt-8 ml-4 w-full md:w-72 lg:w-80 animate-fade-in text-center border-t-2 border-pink-500 pt-4">
            <h2 className="text-lg md:text-xl font-bold text-pink-500 tracking-wider">
              ZY kvadrat nekretnine
            </h2>
            <p className="mt-2 md:mt-4 text-sm md:text-base text-gray-300 leading-relaxed shadow-md">
              Dug period uspešno posredujemo na tržištu nekretnina u Novom Sadu. Lista naših zadovoljnih klijenata je dugačka.
              Težimo da svojim klijentima obezbedimo potpunu podršku, razumevanje u njihovim zahtevima i očekivanjima.
            </p>
            <p className="mt-2 md:mt-4 text-sm md:text-base text-gray-300 leading-relaxed shadow-md">
              Agencija ZY kvadrat nekretnine je upisana u Registar posrednika u prometu i zakupu nepokretnosti pod brojem 1122.
            </p>
          </div>
        )}
      </section>

      {/* Slideshow i ostale komponente za veće ekrane */}
      <div
        className="absolute hidden md:block w-full md:w-1/3 h-64 md:h-[80%] p-4 md:p-0 md:right-0 md:top-20 md:mr-32 md:mt-32 slideshow-large"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="text-center mb-4 text-lg font-bold text-pink-500 relative">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-0.5 bg-pink-500" style={{ marginTop: '-20px' }} />
          <span className="animate-pulse">{slideshowTitles[currentSlideshow]}</span>
        </div>
        <div className="relative">
          <Slideshow
            images={currentSlideshow === 0 ? stan1Images : currentSlideshow === 1 ? stan2Images : stan3Images}
            isPaused={isPaused}
          />
          <StanInfo adresa={slideshowTitles[currentSlideshow]} />
        </div>
      </div>

      {/* KontaktInfo za veće ekrane */}
      <div
        className="absolute hidden md:block z-40"
        style={{ bottom: '20%', left: '28%' }}
      >
        <KontaktInfo />
      </div>

      {/* Dugmad za veće ekrane */}
      <div className="absolute left-1/2 bottom-10 transform -translate-x-1/2 hidden md:flex space-x-4">
        <button
          className="bg-pink-600 text-white py-3 px-8 rounded-lg hover:bg-pink-700 transition-all button-large"
          onClick={handleIzdavanjeClick}
        >
          IZNAJMI
        </button>
        <button
          className="bg-pink-600 text-white py-3 px-8 rounded-lg hover:bg-pink-700 transition-all button-large"
          onClick={handleProdajaClick}
        >
          KUPI
        </button>
      </div>
    </div>
  );
});

export default Home;
